import React, { useState, useContext, ChangeEvent, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBRLocale from 'date-fns/locale/pt-BR';
import api from '~/services/api';
import Dates from '~/utils/dates';
import Validation from './validation';
import './styles.css';

// Contexts
import { GeneralContext, ModalContext } from '~/contexts';

// Componentes
import CurrencyInput from '~/components/Modules/CurrencyMask';
import { Button } from '~/components/Parts/Forms';
import { FiLoader } from 'react-icons/fi';
import { TextField } from '@mui/material';

// Current Date
let newDate = new Date();

// Base Data
let billDataDefault = {
    unit_id: 0,
    provider: '',
    type: 'FreeMarket',
    tariff_modality: 'Verde',
    supplied_voltage: 'A4',
    contracted_energy_demand: '',
    total_value_due: '',
    bill_number: `Manual_${newDate.getUTCFullYear() + '-' + ((newDate.getUTCMonth()+1)<=9 ? '0' : '') + (newDate.getUTCMonth()+1) + '-' + ((newDate.getUTCDate()+1)<=9 ? '0' : '') + newDate.getUTCDate()}`,
    reference_date: '',
    read_dates: {
        last: '',
        current: '',
        next: ''
    },
    tax_liquot: {
        icms: '',
        pis: '',
        cofins: ''
    },
    bill_items: {
        demand: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        demandNoIcms: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        demandPeak: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        demandOffPeak: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        demandNoIcmsPeak: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        demandNoIcmsOffPeak: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        consumptionPeakHoursTUSD: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        consumptionOffPeakHoursTUSD: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        demandOvertaking: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        reactiveEnergyPeakHours: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        reactiveEnergyOffPeakHours: {
            amount: 0,
            tariff: {
                icms: 0,
                noicms: 0
            },
            value: {
                icms: 0,
                total: 0
            },
        },
        freeMarketValues: {
            covid: 0
        },
        others: {
            publicIllumination: 0,
            fee: 0,
            interest: 0,
            currencyCorrection: 0,
            discounts: 0
        }
    }
}

const Form: React.FC<any> = ({setBillError, setReady, bill, setErrorModal}) => {
    const [content, setContent]         = useState<string>('infos');
    const [billData, setBillData]       = useState<any>(bill?.bill_items ? setBillDataEdit() : billDataDefault);
    const [errors, setErrors]           = useState<any>(null);
    const [buttonReady, setButtonReady] = useState<any>(true);
    const [inputDates, setInputDates]   = useState<any>({reference: '', last: '', current: '', next: ''});
    const [dateOpen, setDatesOpen]      = useState<any>({reference: false, last: false, current: false, next: false});
    const [messageErrorForm, setMessageErrorForm] = useState<string>('');
    // Contexts
    const {user, unit} = useContext(GeneralContext);
    const Modal  = useContext(ModalContext);

    function changeTab(tab: string) {
        if (tab!==content) setContent(tab)
    }

   function setBillDataEdit(){
        let ret = {
            ...billDataDefault,
            id                               : bill.id,
            bill_items                       : bill.bill_items,
            provider                         : bill.provider,
            reference_date                   : bill.reference_date,
            supplied_voltage                 : bill.supplied_voltage.type,
            tariff_modality                  : bill.tariff_modality,
            contracted_energy_demand_peak    : bill.contracted_energy_demand.peakHours,
            contracted_energy_demand_off_peak: bill.contracted_energy_demand.offPeakHours,
            contracted_energy_demand         : bill.contracted_energy_demand,
            tax_liquot                       : bill.tax_liquot,
            bill_number                      : bill.bill_number,
            total_value_due                  : bill.total_value_due,
        }

        return ret
    }

    function setDateOpen (type: string, status: boolean) {
        setDatesOpen({...dateOpen, [type]: status})
    }

    async function save () {
        setButtonReady(false)

        let validations = Validation.fields(billData);
        let dataApi = {
            ...billData,
            contracted_energy_demand : (billData.tariff_modality==="Azul") ?
                { peakHours: billData.contracted_energy_demand_peak, offPeakHours:billData.contracted_energy_demand_off_peak } :
                billData.contracted_energy_demand
        }
        renderErrorsApi(validations)
        setErrors(validations)

        if (!validations) {
            await api.post('bills/manual', dataApi, {
                headers: { Authorization: user.token }
            }).then((resp: any) => {
                if(resp.data.error === true){
                    renderErrorsApi(resp.data)
                }else{
                    if(setReady !== undefined) setReady(false)
                    if(setBillError !== undefined) setBillError(null)
                    Modal.setModalOpen(false)
                    if(resp.data.res.status === false){
                        setErrorModal()
                    }
                }
            }).catch(err => {
                console.log(err);
            });
        }
        setButtonReady(true)
    }

    function onChange(event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) {
        const {name, value} = event.target;
        const data = {[name]: (name==='active' ? Number(value) : value)};
        setBillData({...billData, ...data});
    }

    function onChangeFloat(event: ChangeEvent<HTMLInputElement | HTMLSelectElement>, originalValue: any, maskedValue: any) {
        let {name}    = event.target
        let data: any = {[name]: originalValue}
        let newData   = JSON.parse(JSON.stringify(billData))

        // Check if is a object
        if (name.indexOf('.')>=0) {
            let nBase    = name.split('.')
            name = nBase[0]

            if (nBase.length===2) data = {[nBase[0]]: { [nBase[1]]: originalValue}}
            else if (nBase.length===3) data = {[nBase[0]]: { [nBase[1]]: { [nBase[2]]: originalValue}}}
            else if (nBase.length===4) data = {[nBase[0]]: { [nBase[1]]: { [nBase[2]]: { [nBase[3]]: originalValue}}}}
        }

        mergeDeep(newData, data)
        setBillData(newData)
    }

    function onChangeDate (date: any, type: string) {
        let data    = {}
        let newData = JSON.parse(JSON.stringify(billData))
        let newDate = Dates.getDateDBFormatted(date)

        if (type==='reference') data = {reference_date: newDate}
        else data = {read_dates: {[type]: newDate}}

        mergeDeep(newData, data)
        setBillData(newData)
        setInputDates({...inputDates, [type]: Dates.getDateFormatted(date, (type==='reference' ? 'mm/yyyy' : 'dd/mm/yyyy'))})
    }

    function isObject(item: any) {
        return (item && typeof item==='object' && !Array.isArray(item));
    }

    function mergeDeep (target: any, ...sources: any) {
        if (!sources.length) return target;
        const source = sources.shift();

        if (isObject(target) && isObject(source)) {
            for (const key in source) {
                if (isObject(source[key])) {
                    if (!target[key]) Object.assign(target, { [key]: {} });
                    mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }

        return target;
    }

    function getBillFields (item: string, required?: boolean) {
        return <>
            <div className="input-group" title={errors && errors.bill_items && errors.bill_items[item] && errors.bill_items[item].amount ? errors.bill_items[item].amount : ""}>
                <label htmlFor={`bill_items.${item}.amount`}>Quantidade</label>
                <CurrencyInput
                    id={`bill_items.${item}.amount`}
                    className={errors && errors.bill_items && errors.bill_items[item] && errors.bill_items[item].amount ? "error" : ""}
                    name={`bill_items.${item}.amount`} placeholder="0,00"
                    onChangeValue={onChangeFloat}
                    value={billData.bill_items[item] && billData.bill_items[item].amount ? billData.bill_items[item].amount : ''}
                    hideSymbol
                />
            </div>

            <div className="input-group" title={errors && errors.bill_items && errors.bill_items[item] && errors.bill_items[item].total ? errors.bill_items[item].total : ""}>
                <label htmlFor={`bill_items.${item}.value.total`}>Total (R$)</label>
                <CurrencyInput
                    id={`bill_items.${item}.value.total`}
                    className={errors && errors.bill_items && errors.bill_items[item] && errors.bill_items[item].total ? "error" : ""}
                    name={`bill_items.${item}.value.total`} placeholder="0,00"
                    onChangeValue={onChangeFloat}
                    value={billData.bill_items[item] && billData.bill_items[item].value && billData.bill_items[item].value.total ? billData.bill_items[item].value.total : ''}
                    hideSymbol
                />
            </div>
        </>
    }

    async function renderErrorsApi(validation:any){
        if (validation) {
             if (validation && validation.error !== true) {
                setMessageErrorForm("Preencha todos os campos");
            }else if (validation.error === true) {
                setMessageErrorForm(validation.message);
            }
        }
    }

    // Inicializa `unit_id` uma única vez quando o modal abre (evita loop de setState).
    useEffect(() => {
        setBillData((prev: any) => {
            if (prev?.unit_id && Number(prev.unit_id) !== 0) return prev;

            // edição
            if (bill?.bill_items) {
                const billUnitId = bill?.unit?.id ? Number(bill.unit.id) : 0;
                return billUnitId ? { ...prev, unit_id: billUnitId } : prev;
            }

            // cadastro manual
            const unitId = unit?.id ? Number(unit.id) : 0;
            return unitId ? { ...prev, unit_id: unitId, billErrors: bill } : prev;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bill, unit?.id]);

    // Resolve o nome do provider com base na unidade atual (shape atual: unit.provider.provider_id).
    useEffect(() => {
        if (!user?.token) return;
        if (billData?.provider && String(billData.provider).trim() !== '') return;

        const providerId =
            unit?.provider?.provider_id ??
            unit?.provider?.provider?.id ??
            0;

        if (!providerId) return;

        api.get('clients/providers', { headers: { Authorization: user.token } })
            .then((resp) => {
                const list: any[] = Array.isArray(resp?.data) ? resp.data : [];
                const providerDB = list.find((el: any) => Number(el?.id) === Number(providerId));
                const providerName = providerDB?.name ? String(providerDB.name) : '';
                if (!providerName) return;
                setBillData((prev: any) => ({ ...prev, provider: providerName }));
            })
            .catch(() => {
                // Silencioso: provider é apenas informativo; não pode quebrar o modal.
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.token, unit?.provider?.provider_id, unit?.provider?.provider?.id, billData?.provider]);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBRLocale}>
            <div className="tabs">
                <div className={ `tab-infos${content==='infos' ? ' active' : ''}` } onClick={() => changeTab('infos') }>Infos</div>
                <div className={ `tab-bill-items${content==='bill-items' ? ' active' : ''}` } onClick={() => changeTab('bill-items') }>Bill Items</div>
            </div>

            <form method="post" onSubmit={(event: React.FormEvent<HTMLFormElement>) => event.preventDefault()} className="editBills">
                {
                    content==='infos' ? <>
                        <div className="form-group no-margin">
                            <div className="input-group">
                                <label htmlFor="type">Tipo de Conta</label>
                                <select name="type" id="type" onChange={onChange} value={billData.type} disabled={true}>
                                    <option value="FreeMarket">Mercado Livre</option>
                                </select>
                            </div>

                            <div className="input-group">
                                <label htmlFor="tariff_modality">Modalidade</label>
                                <select name="tariff_modality" id="tariff_modality" onChange={onChange} value={billData.tariff_modality}>
                                    <option value="Azul">Azul</option>
                                    <option value="Verde">Verde</option>
                                </select>
                            </div>

                            <div className="input-group">
                                <label htmlFor="supplied_voltage">Tipo de Tensão</label>
                                <select name="supplied_voltage" id="supplied_voltage" onChange={onChange} value={billData.supplied_voltage}>
                                    <option value="A3">A3</option>
                                    <option value="A3a">A3a</option>
                                    <option value="A4">A4</option>
                                    <option value="AS">AS</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            { billData.tariff_modality==="Verde" &&
                                <div className="input-group" title={errors && errors.contracted_energy_demand ? errors.contracted_energy_demand : ""}>
                                    <label htmlFor="contracted_energy_demand">Demanda Contratada Única <sup title="Campo obrigatório">*</sup></label>
                                    <CurrencyInput
                                        id="contracted_energy_demand"
                                        className={errors && errors.contracted_energy_demand ? "error" : ""}
                                        name="contracted_energy_demand" placeholder="0,00"
                                        onChangeValue={onChangeFloat}
                                        value={billData.contracted_energy_demand ? billData.contracted_energy_demand : ''}
                                        hideSymbol
                                    />
                                </div>
                            }
                            <div className="input-group" title={errors && errors.total_value_due ? errors.total_value_due : ""}>
                                <label htmlFor="total_value_due">Total da Conta (R$) <sup title="Campo obrigatório">*</sup></label>
                                <CurrencyInput
                                    id="total_value_due"
                                    className={errors && errors.total_value_due ? "error" : ""}
                                    name="total_value_due" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.total_value_due ? billData.total_value_due : ''}
                                    hideSymbol
                                />
                            </div>

                            <div className="input-group" title={errors && errors.reference_date ? errors.reference_date : ""}>
                                <label htmlFor="reference_date">Data de Referência <sup title="Campo obrigatório">*</sup></label>
                                <input id="reference_date" className={errors && errors.reference_date ? "error" : ""} name="reference_date" type="text" placeholder='10/2020' data-type="date" value={inputDates.reference} onClick={() => {setDateOpen('reference', !dateOpen.reference)}} readOnly />
                                <DatePicker
                                    open={dateOpen.reference}
                                    onOpen={() => setDateOpen('reference', true)}
                                    onClose={() => setDateOpen('reference', false)}
                                    value={new Date(billData.reference_date)}
                                    disableFuture
                                    onChange={(date) => onChangeDate(date, 'reference')}
                                    views={['year', 'month']}
                                    renderInput={(params) => (
                                        <TextField {...params} size="small" variant="outlined" fullWidth />
                                    )}
                                />
                            </div>
                        </div>

                        { billData.tariff_modality==="Azul" && (
                                <div className="form-group">
                                    <div className="input-group" title={errors && errors.contracted_energy_demand_peak ? errors.contracted_energy_demand_peak : ""}>
                                        <label htmlFor="contracted_energy_demand_peak">Demanda Contratada Ponta <sup title="Campo obrigatório">*</sup></label>
                                        <CurrencyInput
                                            id="contracted_energy_demand_peak"
                                            className={errors && errors.contracted_energy_demand_peak ? "error" : ""}
                                            name="contracted_energy_demand_peak" placeholder="0,00"
                                            onChangeValue={onChangeFloat}
                                            value={billData.contracted_energy_demand_peak ? billData.contracted_energy_demand_peak : ''}
                                            hideSymbol
                                        />
                                    </div>
                                    <div className="input-group" title={errors && errors.contracted_energy_demand_off_peak ? errors.contracted_energy_demand_off_peak : ""}>
                                        <label htmlFor="contracted_energy_demand_off_peak">Demanda Contratada Fora Ponta <sup title="Campo obrigatório">*</sup></label>
                                        <CurrencyInput
                                            id="contracted_energy_demand_off_peak"
                                            className={errors && errors.contracted_energy_demand_off_peak ? "error" : ""}
                                            name="contracted_energy_demand_off_peak" placeholder="0,00"
                                            onChangeValue={onChangeFloat}
                                            value={billData.contracted_energy_demand_off_peak ? billData.contracted_energy_demand_off_peak : ''}
                                            hideSymbol
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="form-group">
                            <div className="input-group" title={errors && errors.tax_liquot_icms ? errors.tax_liquot_icms : ""}>
                                <label htmlFor="tax_liquot.icms">ICMS (%) <sup title="Campo obrigatório">*</sup></label>
                                <CurrencyInput
                                    id="tax_liquot.icms"
                                    className={errors && errors.tax_liquot_icms ? "error" : ""}
                                    name="tax_liquot.icms" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.tax_liquot.icms ? billData.tax_liquot.icms : ''}
                                    hideSymbol
                                />
                            </div>

                            <div className="input-group" title={errors && errors.tax_liquot_pis ? errors.tax_liquot_pis : ""}>
                                <label htmlFor="tax_liquot.pis">PIS (%) <sup title="Campo obrigatório">*</sup></label>
                                <CurrencyInput
                                    id="tax_liquot.pis"
                                    className={errors && errors.tax_liquot_pis ? "error" : ""}
                                    name="tax_liquot.pis" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.tax_liquot.pis ? billData.tax_liquot.pis : ''}
                                    hideSymbol
                                />
                            </div>

                            <div className="input-group" title={errors && errors.tax_liquot_cofins ? errors.tax_liquot_cofins : ""}>
                                <label htmlFor="tax_liquot.cofins">Cofins (%) <sup title="Campo obrigatório">*</sup></label>
                                <CurrencyInput
                                    id="tax_liquot.cofins"
                                    className={errors && errors.tax_liquot_cofins ? "error" : ""}
                                    name="tax_liquot.cofins" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.tax_liquot.cofins ? billData.tax_liquot.cofins : ''}
                                    hideSymbol
                                />
                            </div>
                        </div>
                    </> : <>
                        {
                            billData.tariff_modality==='Verde' ?
                                <div className="box">
                                    <div className="col">
                                        <h3>Demanda Faturada<sup title="Campo obrigatório">*</sup></h3>
                                        <div className="form-group no-margin">
                                            {getBillFields('demand')}
                                        </div>
                                    </div>

                                    <div className="col">
                                        <h3>Demanda Sem ICMS</h3>
                                        <div className="form-group no-margin">
                                            {getBillFields('demandNoIcms')}
                                        </div>
                                    </div>
                                </div> : <>
                                <div className="box">
                                    <div className="col">
                                        <h3>Demanda Faturada Ponta <sup title="Campo obrigatório">*</sup></h3>
                                        <div className="form-group no-margin">
                                            {getBillFields('demandPeak')}
                                        </div>
                                    </div>

                                    <div className="col">
                                        <h3>Demanda Faturada Fora Ponta <sup title="Campo obrigatório">*</sup></h3>
                                        <div className="form-group no-margin">
                                            {getBillFields('demandOffPeak')}
                                        </div>
                                    </div>
                                </div>

                                <div className="box">
                                    <div className="col">
                                        <h3>Demanda Ponta Sem ICMS</h3>
                                        <div className="form-group no-margin">
                                            {getBillFields('demandNoIcmsPeak')}
                                        </div>
                                    </div>

                                    <div className="col">
                                        <h3>Demanda Fora Ponta Sem ICMS</h3>
                                        <div className="form-group no-margin">
                                            {getBillFields('demandNoIcmsOffPeak')}
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        <div className="box">
                            <div className="col">
                                <h3>Consumo Ponta TUSD <sup title="Campo obrigatório">*</sup></h3>
                                <div className="form-group no-margin">
                                    {getBillFields('consumptionPeakHoursTUSD')}
                                </div>
                            </div>

                            <div className="col">
                                <h3>Consumo Fora Ponta TUSD <sup title="Campo obrigatório">*</sup></h3>
                                <div className="form-group no-margin">
                                    {getBillFields('consumptionOffPeakHoursTUSD')}
                                </div>
                            </div>
                        </div>

                        <div className="box">
                            <div className="col">
                                <h3>Energia Reativa Ponta</h3>
                                <div className="form-group no-margin">
                                    {getBillFields('reactiveEnergyPeakHours')}
                                </div>
                            </div>

                            <div className="col">
                                <h3>Energia Reativa Fora Ponta</h3>
                                <div className="form-group no-margin">
                                    {getBillFields('reactiveEnergyOffPeakHours')}
                                </div>
                            </div>
                        </div>

                        {
                            billData.tariff_modality==='Verde' ? <>
                                <h3>Ultrapassagem de Demanda</h3>
                                <div className="form-group no-margin">
                                    {getBillFields('demandOvertaking')}
                                </div>
                            </> : <>
                                <div className="box">
                                    <div className="col">
                                        <h3>Ultrapassagem de Demanda Ponta</h3>
                                        <div className="form-group no-margin">
                                            {getBillFields('demandOvertakingPeak')}
                                        </div>
                                    </div>

                                    <div className="col">
                                        <h3>Ultrapassagem de Demanda Fora Ponta</h3>
                                        <div className="form-group no-margin">
                                            {getBillFields('demandOvertakingOffPeak')}
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        <h3>Mercado Livre</h3>
                        <div className="form-group no-margin">
                            <div className="input-group">
                                <label htmlFor="bill_items.freeMarketValues.covid">Conta COVID</label>
                                <CurrencyInput
                                    id="bill_items.freeMarketValues.covid" name="bill_items.freeMarketValues.covid" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.bill_items.freeMarketValues && billData.bill_items.freeMarketValues.covid ? billData.bill_items.freeMarketValues.covid : ''}
                                    hideSymbol
                                />
                            </div>
                        </div>

                        <h3>Outros Valores</h3>
                        <div className="form-group no-margin">
                            <div className="input-group">
                                <label htmlFor="bill_items.others.publicIllumination">Iluminação Pública</label>
                                <CurrencyInput
                                    id="bill_items.others.publicIllumination" name="bill_items.others.publicIllumination" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.bill_items.others.publicIllumination ? billData.bill_items.others.publicIllumination : ""}
                                    hideSymbol
                                />
                            </div>

                            <div className="input-group">
                                <label htmlFor="bill_items.others.fee">Multa</label>
                                <CurrencyInput
                                    id="bill_items.others.fee" name="bill_items.others.fee" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.bill_items.others.fee ? billData.bill_items.others.fee : ""}
                                    hideSymbol
                                />
                            </div>

                            <div className="input-group">
                                <label htmlFor="bill_items.others.interest">Juros</label>
                                <CurrencyInput
                                    id="bill_items.others.interest" name="bill_items.others.interest" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.bill_items.others.interest ? billData.bill_items.others.interest : ""}
                                    hideSymbol
                                />
                            </div>

                            <div className="input-group">
                                <label htmlFor="bill_items.others.currencyCorrection">Correção Monetária</label>
                                <CurrencyInput
                                    id="bill_items.others.currencyCorrection" name="bill_items.others.currencyCorrection" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.bill_items.others.currencyCorrection ? billData.bill_items.others.currencyCorrection : ""}
                                    hideSymbol
                                />
                            </div>

                            <div className="input-group">
                                <label htmlFor="billData.bill_items.others.discounts">Descontos</label>
                                <CurrencyInput
                                    id="bill_items.others.discounts" name="bill_items.others.discounts" placeholder="0,00"
                                    onChangeValue={onChangeFloat}
                                    value={billData.bill_items.others.discounts ? billData.bill_items.others.discounts : ""}
                                    hideSymbol
                                />
                            </div>
                        </div>
                    </>
                }
            </form>
            <div className="errors">
                <div>
                    <p>{messageErrorForm}</p>
                </div>
            </div>

            <footer>
                <Button
                    type="button"
                    id="btnSave"
                    func={() => save()}
                    text={buttonReady ? 'Salvar' : 'Salvando...'}
                    icon={!buttonReady && <FiLoader size={10} />}
                    className={`${buttonReady ? 'btnSave' : 'btnLoad'}`}
                    disabled={buttonReady ? false : true}
                />

                <button id="btnCancel" type="button" onClick={() => Modal.setModalOpen(false)}>Cancelar</button>
            </footer>
        </LocalizationProvider>
    );
}

export default Form;